"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var path_browserify_1 = __importDefault(require("path-browserify")); //TODO - bad name


function subPaths(pathname) {
  var folders = [];
  var currentFolder = pathname;

  while (path_browserify_1.default.dirname(currentFolder) !== currentFolder) {
    //strip '.../' at the end of folder names.
    var folderName = stripTrailingSlash(currentFolder);
    folders.unshift(folderName);
    currentFolder = path_browserify_1.default.dirname(currentFolder);
  } //add root folder '/' or '.'


  folders.unshift(currentFolder);
  return folders;
}

exports.subPaths = subPaths;

function stripTrailingSlash(pathname) {
  if (pathname === '/') return pathname;
  return pathname.replace(/\/$/, '');
}